import React from 'react';
import MainLayout from '../components/Layout/MainLayout.js';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts.js';

const BlogPage = () => {
    return (
        <MainLayout>
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <h1 className="text-3xl font-bold font-montserrat text-gray-900 mb-2">
                    Blog & Guides
                </h1>
                <p className="text-gray-600 mb-8">Læs praktiske artikler om SEO, hjemmeside og markedsføring for håndværkere. Klar til at komme i gang? <Link to="/onboarding" className="text-brand-dark underline">Opret din hjemmeside</Link>.</p>
                <div className="max-w-4xl">
                    <div className="grid gap-8">
                        {blogPosts.map(post => (
                            <article key={post.id} className="bg-white shadow rounded-lg overflow-hidden">
                                <div className="p-6">
                                    <div className="flex items-center text-sm text-gray-500 mb-2">
                                        <span>{post.date}</span>
                                        <span className="mx-2">•</span>
                                        <span>{post.category}</span>
                                    </div>
                                    <h2 className="text-xl font-semibold font-montserrat text-gray-900 mb-3">
                                        {post.title}
                                    </h2>
                                    <p className="text-gray-600 mb-4">
                                        {post.excerpt}
                                    </p>
                                    <Link 
                                        to={`/blog/${post.slug}`} 
                                        className="text-amber-800 hover:text-amber-900 font-medium"
                                    >
                                        Læs mere →
                                    </Link>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default BlogPage;